/* @flow */

import * as types from 'src/shared/domain/braindate/action/braindateActionTypes';
import {
  createReducer,
  setRequestResult,
  setFetchingState,
  unsetFetchingState,
} from 'src/shared/core/util/reducerUtils';

const initialState = {
  result: [],
  isFetching: false,
};

const _createBraindate = (state: Object, action: Object) => {
  const { result } = state;
  const { braindateId } = action;

  return {
    ...state,
    result: [...result, braindateId],
  };
};

const _deleteBraindate = (state: Object, action: Object) => {
  const { id } = action;
  const { result } = state;
  const index = result.indexOf(id);

  if (index === -1) {
    return state;
  }
  return {
    ...state,
    result: [...result.slice(0, index), ...result.slice(index + 1)],
  };
};

const setBraindateFetchingState = (state: Object, { action }: Object) => {
  const { id } = action;

  return {
    ...state,
    [id]: {
      isFetching: true,
    },
  };
};

const unsetBraindateFetchingState = (state: Object, { action }: Object) => {
  const { id, error } = action;

  return {
    ...state,
    [id]: {
      fetchingError: error,
      isFetching: false,
    },
  };
};

export default createReducer(initialState, {
  [types.SIMULATE_BRAINDATES_FETCH]: setFetchingState,
  [types.FETCH_BRAINDATES_REQUEST]: setFetchingState,
  [types.FETCH_BRAINDATES_SUCCESS]: setRequestResult,
  [types.FETCH_BRAINDATES_FAILURE]: unsetFetchingState,
  [types.FETCH_BRAINDATE_REQUEST]: setBraindateFetchingState,
  [types.FETCH_BRAINDATE_SUCCESS]: unsetBraindateFetchingState,
  [types.FETCH_BRAINDATE_FAILURE]: unsetBraindateFetchingState,
  [types.CREATE_BRAINDATE]: _createBraindate,
  [types.DELETE_BRAINDATE_LOCALLY]: _deleteBraindate,
});
